import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "components/common/BreadCrumb";
import { Container } from "reactstrap";
import { toast } from "react-toastify";
import { getTool } from "features/Tools/services/ToolService";
import { Tool } from "features/Tools/types/tool.types";
import { getDocumentTitle } from "utils/helpers";
import { ToolCreateModal } from "./ToolCreateModal";

/**
 * Deep-link entry for editing a tool; uses the same modal as the list.
 */
const ToolForm = () => {
  document.title = getDocumentTitle("Edit tool");
  const navigate = useNavigate();
  const { id } = useParams();
  const [record, setRecord] = useState<Tool | null>(null);
  const [loadingRecord, setLoadingRecord] = useState(true);

  useEffect(() => {
    if (!id) {
      setLoadingRecord(false);
      return;
    }
    let cancelled = false;
    const load = async () => {
      setLoadingRecord(true);
      try {
        const res = await getTool(Number(id));
        if (!cancelled && res.success) {
          setRecord(res.data);
        } else if (!cancelled) {
          toast.error("Could not load tool");
          navigate("/inventory-management/tools", {
            replace: true,
          });
        }
      } catch (err) {
        console.warn(err);
        if (!cancelled) {
          toast.error("Could not load tool");
          navigate("/inventory-management/tools", {
            replace: true,
          });
        }
      } finally {
        if (!cancelled) setLoadingRecord(false);
      }
    };
    void load();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  const listPath = "/inventory-management/tools";

  const handleClose = () => {
    navigate(listPath, { replace: true });
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Edit tool"
          pageTitle="Inventory Management"
          backTo={{ label: "Tools", path: listPath }}
        />
        {loadingRecord ? (
          <p className="text-muted">Loading…</p>
        ) : record ? (
          <ToolCreateModal
            show
            editingTool={record}
            onClose={handleClose}
            onSuccess={handleClose}
          />
        ) : null}
      </Container>
    </div>
  );
};

export default ToolForm;
